import React from 'react'
import Superface from '../Superface'
import { withRouter } from 'react-router-dom';
import Single from './Single'

class MaterialsKind extends Single{
    
    constructor(props){
        super(props)
        this._type = 'kind'
    }

    renderFeaturedImage(kind){
        if( !Superface.IS_MOBILE_OR_TABLET ){
            
            let path
            
            if( this.props.featuredImage !== '' ){
                path = Superface.assetUrl(this.props.featuredImage)
            }else{
                path = Superface.assetUrl(kind.featured_image.path)
            }
            
            return(
                <div className='single-featured-container' style={{width:'50%', overflow: 'hidden',  position:'relative'}}>
                    <img src={path} alt={ Superface.field( this._single, 'name' ) } />
                </div>
            )
        }
    }

    goToSingle(single){
        this.setState({...this.state, leaving : true, mounted : false})
        this.timeoutChange = setTimeout( () => {
            // console.log('@goToSingle')
            Superface.setKindFeaturedImagePath('')
            Superface.goTo(Superface.uri('matieres') + '/' + single.slug)
        }, 500)
    }


}

export default withRouter(MaterialsKind)


// WEBPACK FOOTER //
// ./src/components/MaterialsKind.js